import error_payload_V0rgpRpxJB from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/error-payload.ts";
import revive_payload_client_4sVQNw7RlN from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import api_GFfDXud5Cr from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/api.ts";
import apple_jPY9uUKXEX from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/apple.ts";
import cookies_rCS2psPm8j from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/cookies.ts";
import errorHandler_x1Y4n5NP4w from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/errorHandler.ts";
import gtag_RbOvmu12fv from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/gtag.ts";
import mitt_S0QU5gJPTl from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/mitt.ts";
import sanitize_fbXCtPd0F2 from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/sanitize.ts";
import vue_i18n_4tPQ9Bsubn from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/vue-i18n.js";
import vue3_tabs_client_rEqNFYF8ZO from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/vue3-tabs.client.ts";
import vue3Lottie_client_Utljt8W8NE from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/vue3Lottie.client.ts";
import vuetify_7h9QAQEssH from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/plugins/vuetify.ts";
export default [
  error_payload_V0rgpRpxJB,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  api_GFfDXud5Cr,
  apple_jPY9uUKXEX,
  cookies_rCS2psPm8j,
  errorHandler_x1Y4n5NP4w,
  gtag_RbOvmu12fv,
  mitt_S0QU5gJPTl,
  sanitize_fbXCtPd0F2,
  vue_i18n_4tPQ9Bsubn,
  vue3_tabs_client_rEqNFYF8ZO,
  vue3Lottie_client_Utljt8W8NE,
  vuetify_7h9QAQEssH
]